import { Injectable } from '@angular/core';
import { FFService } from '../../ff.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { tap } from 'rxjs/operators';
import { EditUserComponent } from '../../../pages/edit_user/edit_user.component';
import { NbWindowService } from '@nebular/theme';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {

  ff;
  endpoint = environment.api_endpoint;

  constructor(
    private ff_service: FFService,
    private auth_service: AuthenticationService,
    private router: Router,
    private http: HttpClient,
    private window_service: NbWindowService) {
    // Fancy Framework
    this.ff = this.ff_service.ff;

    const data = [{
      mime_type: 'descriptive/definition',
      name: 'Application Service',
      title: 'Fancy Framework Application Service',
      headline: 'A Fancy Framework Application Service',
      description: 'The FF Application Service the abstract manager for all things related to applciations. ',
      short_description: 'This service manages applications. ' +
        'Allows the dynamic switches between various applications.',
      description_list: ['Application'],
      keywords: ['navigation', 'interface', 'Application'],
      icon: 'fal fa-flag',
      category: 'navigation',
      subcategory: 'interface',
    }, {
      mime_type: 'system/definition',
      system: 'navigation',
    }, {
      mime_type: 'subsystem/definition',
      subsystem: 'application',
    }, {
      mime_type: 'service/definition',
      service: 'application',
    }];

    const options = [{
      mime_type: 'action_function/definition',
      action_function: this.handle_messages.bind(this),
    }, {
      mime_type: 'subscription_function/definition',
      subscription_function: () => true,
    }];

    this.ff.service(data, options);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////
  // Accepts navigation actions
  // {
  //     mime_type: 'action/definition',
  //     action: 'navigate_to_url',
  //     parameters: [{
  //       mime_type: 'url/definition',
  //       path: '/foo/bar',
  //       target: '_self',
  //     }],
  // }
  handled_actions = [
    'navigate_to_url',
    'authentication:wait_for_mfa_to_complete',
    'application:portal',
    'visualize:user_profile',
    'authentication/edit_user',
  ];
  handle_messages(message) {
    // console.log('DEBUG application_service handle_messages', message )
    const working_actions = message.payload.filter((item) => {
      return this.handled_actions.includes(item.action);
    });
    // console.log(navigations_actions)

    if (working_actions.length === 0) {
      return
    }

    // ACTION navigate_to_url
    const navigations_actions = message.payload.filter((item) => {
      return item.action === 'navigate_to_url';
    })
    const action = navigations_actions[0];
    // Grab path to navigate to
    let url_definitions;
    if (action) {
      if (action.hasOwnProperty('parameters')) {
        url_definitions = action.parameters.filter((param) => {
          if (param.hasOwnProperty('mime_type')) {
            return param.mime_type === 'url/definition' && param.hasOwnProperty('path');
          } else {
            return false;
          }
        });
      }
    }
    // ACTION wait_for_mfa
    const wait_for_mfa_actions = message.payload.filter(item => {
      return item.action === 'authentication:wait_for_mfa_to_complete';
    });
    // TODO hacky doe, but OK
    if (wait_for_mfa_actions.length) {
      url_definitions = [{ path: '/application/authentication/mfa' }];
      this.check_mfa(wait_for_mfa_actions[0].path);
    }
    if (url_definitions) {
      // Use first path if any are found
      this.router.navigate([url_definitions[0].path]);
    } else {
      this.router.navigate(['/portal/404']);
    }

    // ACTION application:portal
    const application_portal_actions = message.payload.filter(item => {
      return item.action === 'application:portal';
    });
    if (application_portal_actions.length) {
      this.router.navigate(['/application/portal']);
    }

    // ACTION application:user_profile
    const view_profile_actions = message.payload.filter(item => {
      return item.action === 'visualize:user_profile';
    });
    if (view_profile_actions.length) {
      // Get profile data
      const request = {
        mime_type: 'get/session',
        uri: this.auth_service.session.uri,
      };
      this.ff.ff_service.request(request).to('/service/session').subscribe(
        data => this.router.navigate(['/application/portal/profile'], { state: { data: data.payload } }),
      );
    }

    // ACTION authentication/edit_user
    const edit_user_actions = message.payload.filter(item => {
      return item.action === 'authentication/edit_user';
    });
    if (edit_user_actions.length) {
      this.window_service.open(EditUserComponent, {
        title: `Edit User`, context: {
          user: { ...this.auth_service.current_user },
        }
      });
    }
  }

  check_mfa(path) {

    this.http.get(`${this.endpoint}${path}`, {
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Basic ${this.auth_service.get_token()}`,
      },
    }).subscribe(
      (response: any) => {
        // console.log('==== check_mfa repsonse')
        // console.log(response)
        if (response.hasOwnProperty('state') && response.state.hasOwnProperty('is_pending')) {
          if (response.state.is_pending) {
            setTimeout(() => this.check_mfa(path), 5000);
          } else {
            this.handle_messages({ payload: [response] });
          }
        } else {
          this.handle_messages({ payload: [response] });
        }
      },
      (err) => {
        setTimeout(() => this.check_mfa(path), 5000);
      },
      () => { },
    );
  }
}

